import script from './SdsPulseIndicator.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;_vm._self._c||_h;return _vm._m(0)};
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"sds-pulse-indicator"},[_c('span',{staticClass:"sds-pulse-indicator__animated"})])}];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-19713566_0", { source: ".sds-pulse-indicator[data-v-19713566]{display:inline-flex;align-items:center;justify-content:center;width:12px;height:12px}.sds-pulse-indicator__animated[data-v-19713566]{display:block;width:4px;height:4px;background-color:var(--system-graphics-on-elevation-info);border-radius:50%;box-shadow:0 0 0 4px rgba(0,113,216,.24);animation:pulse-data-v-19713566 1.35s infinite}@keyframes pulse-data-v-19713566{0%{box-shadow:0 0 0 3px rgba(0,113,216,.16)}70%{box-shadow:0 0 0 4px rgba(0,113,216,.24)}100%{box-shadow:0 0 0 3px rgba(0,113,216,.16)}}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-19713566";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
